import formatActivity from 'utils/format-activity.js';

angular
.module('inkfinder')
.factory('Activity', function Activity(
  $http,
  ENDPOINT,
  Session,
  AlertMessages,
  _
) {
  // Public methods
  Activity.get = get;

  /**
   * @name get
   * @description Get an object's activity based on ID and type.
   * @param {string} contentType The contentType of the object to retrieve.
   * @param {number} objectId The ID of the object to retrieve.
   * @return {array} Returns the array of activity
   */
  function get(contentType, objectId) {
    let role = Session.activeState.role;
    let url = ENDPOINT.server + 'activities/api/v1.1/?role=' + role +
    '&content_type=' + contentType + '&object_id=' + objectId;
    if (!_.isUndefined(Session.activeState.association)) {
      url += '&association_id=' + Session.activeState.association.id;
    }
    return $http.get(url).then(function(response) {
      let formattedActivity =
      formatActivity(contentType, response.data);
      return formattedActivity;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }
  return Activity;
});



// WEBPACK FOOTER //
// ./components/activity/activity.service.js